import { gql } from "@apollo/client";

export const EMAIL_CATALOG = gql`
  query EmailCatalog($category: String, $q: String) {
    emailCatalog(category: $category, q: $q) {
      id
      name
      category
      recipients {
        kind
        userTypes
        entityTypes
        fields
        email
        role
        when
      }
      trigger
      from {
        email
        role
      }
      variants
      notes
    }
  }
`;

export const PREVIEW_EMAIL = gql`
  query PreviewEmail($id: ID!, $variant: String) {
    previewEmail(id: $id, variant: $variant) {
      id
      variant
      subject
      html
      meta {
        id
        name
        category
        recipients {
          kind
          userTypes
          entityTypes
          fields
          email
          role
          when
        }
        trigger
        from {
          email
          role
        }
        variants
        notes
      }
    }
  }
`;

export const CUSTODIAN_ADVISOR_NOTIFY_PREVIEW = gql`
  query CustodianAdvisorNotifyPreview($entityId: ID!) {
    custodianAdvisorNotifyPreview(entityId: $entityId) {
      firmCount
      emailCount
      custodianName
      public
      institutionMatched
    }
  }
`;

export const EMAIL_CATALOG_FILTER_OPTIONS = gql`
  query EmailCatalogFilterOptions {
    emailCatalogFilterOptions {
      categories
      recipientKinds
      userTypes
      entityTypes
      companyMailboxes
      fromEmails
    }
  }
`;
